export type OnboardingConnectionFeedback = {
  message: string;
  type: "info" | "error";
  duration?: number;
};

export const CONNECTION_NOT_COMPLETED_TOAST_DURATION_MS = 7000;

type ResolveOnboardingConnectionFeedbackOptions = {
  error: unknown;
  fallbackMessage: string;
  notCompletedMessage: string;
};

const CONNECTION_NOT_COMPLETED_PATTERNS = [
  /modal blocked by browser/i,
  /connection (?:was )?cancell?ed/i,
  /connection dialog was closed/i,
  /authorization (?:was )?cancell?ed/i,
  /authorization (?:window )?was closed/i,
  /window was closed before .*connection/i,
];

const getConnectionErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message.trim();
  }

  return typeof error === "string" ? error.trim() : "";
};

export const resolveOnboardingConnectionFeedback = ({
  error,
  fallbackMessage,
  notCompletedMessage,
}: ResolveOnboardingConnectionFeedbackOptions): OnboardingConnectionFeedback => {
  const errorMessage = getConnectionErrorMessage(error);
  const connectionWasNotCompleted = CONNECTION_NOT_COMPLETED_PATTERNS.some(
    (pattern) => pattern.test(errorMessage),
  );

  if (connectionWasNotCompleted) {
    return {
      message: notCompletedMessage,
      type: "info",
      duration: CONNECTION_NOT_COMPLETED_TOAST_DURATION_MS,
    };
  }

  return {
    message: errorMessage || fallbackMessage,
    type: "error",
  };
};
